/**
 * Formats a ski code.
 * Add a space after every 5th character.
 * Example: "X1Y2W3Z4" becomes "X1Y2W 3Z4"
 */
export const formatSki = (ski: string | null | undefined): string => {
  if (!ski) return ''

  const skiChunks: string[] = []

  for (let index = 0; index < ski.length; index += 5) {
    skiChunks.push(ski.substring(index, index + 5))
  }

  return skiChunks.join(' ')
}
